import React from "react";
import { useApp } from "@/state/AppContext";

/** C4 — the numbered "How it works" / "How pricing works" strip (solar/service/ISP), reading
 * `storefront_config.profile.how_it_works` (owner-entered, ≤5 steps, `directory/routes.py`'s
 * `ProfileConfigIn` — schema landed in Storefront S1). Hidden entirely when empty — never a
 * placeholder step, per `STOREFRONT_BRIEF.md`'s owner decisions. English-only, like every other
 * `profile` field (no `_hi` sibling), so `localized()` is not used here. */
export function HowItWorksBlock({ business }) {
  const { t } = useApp();
  const steps = business.storefront_config?.profile?.how_it_works || [];
  if (steps.length === 0) return null;

  return (
    <div data-testid="storefront-how-it-works">
      <h3 className="font-heading text-lg font-semibold">{t("storefront.howItWorks.title")}</h3>
      <div className="mt-3.5 grid gap-4 sm:grid-cols-2 lg:grid-cols-4">
        {steps.map((step, i) => (
          <div
            key={i}
            className="border-l-2 border-[hsl(var(--accent))] pl-3.5"
            data-testid={`storefront-how-it-works-step-${i}`}
          >
            <span className="tabular-nums text-xs font-bold text-[hsl(var(--accent-ink))]">
              {String(i + 1).padStart(2, "0")}
            </span>
            <p className="mt-1 font-heading text-sm font-semibold">{step.title}</p>
            <p className="mt-1 text-[13px] leading-relaxed text-muted-foreground">{step.body}</p>
          </div>
        ))}
      </div>
    </div>
  );
}
